import useCreditApplications from "hooks/donations/useCreditApplications";
import React, { useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

export const ApprovalModal = ({
  showModal,
  setShowModal,
  creditAppId,
  actionType,
  onActionSuccess,
}) => {
  const [notes, setNotes] = useState("");
  const { addCreditApplicationAction } = useCreditApplications();
  const [isSubmittting, setIsSubmitting]= useState(false);


    // ui labels
  const actionConfig = {
    APPROVE: {
      title: "Approve Credit Application",
      buttonText: "Approve",
      variant: "success",
      message: "Are you sure you want to approve this application?",
    },

    DENY: {
      title: "Decline Credit Application",
      buttonText: "Decline",
      variant: "danger",
      message: "Are you sure you want to decline this application?",
    },

    CANCEL: {
      title: "Cancel Application",
      buttonText: "Cancel Application",
      variant: "secondary",
      message: "This will close the application permanently.",
    },

    UNDER_REVIEW: {
      title: "Move to Under Review",
      buttonText: "Move to Review",
      variant: "primary",
      message: "Move this application into review stage?",
    },

    INQUIRE: {
      title: "Make an inquiry about application",
      buttonText: "Send Request",
      variant: "info",
      message: "Make inquiry request",
    },

    PAUSE: {
      title: "Pause Application",
      buttonText: "Pause",
      variant: "warning",
      message: "Pause processing of this application?",
    },

    MORE_INFO: {
      title: "Request More Information",
      buttonText: "Request Info",
      variant: "dark",
      message: "Request additional information from applicant?",
    },
  };

  const currentAction = actionConfig[actionType] || actionConfig.APPROVE;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!notes.trim()) {
      toast.error("Please provide a note for this action.");
      return;
    }

    const payload = {
      type: actionType,
      notes,
    };

    try {
        const res = await addCreditApplicationAction(creditAppId, payload);
        if (onActionSuccess) onActionSuccess(res, actionType);
    } catch (err) {
      // error handled inside hook
      console.log(err);
    } finally {
      setShowModal(false);
      setNotes("");
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      centered
      className="modal-small-text"
    >
      <Modal.Header className="py-2 pt-3 px-4 fw-bold" style={{ fontSize: 14 }}>
        {currentAction.title}
      </Modal.Header>
      <Modal.Body style={{ fontSize: "0.83rem" }} className="px-4">
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Add a note for the applicant..."
              required
            />
          </Form.Group>

          <div className="d-flex justify-content-start mt-4">
            <Button
              size="sm"
              variant="secondary"
              onClick={() => setShowModal(false)}
              className="me-2"
            >
              Cancel
            </Button>
            {isSubmittting ? (
              <Spinner size="sm" animation="border" vvariant={currentAction.variant} />
            ) : (
              <Button
                size="sm"
                type="submit"
                variant={currentAction.variant}
                disabled={!notes}
              >
                {currentAction.buttonText}
              </Button>
            )}
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
